import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../services/ApiService'
import { showAlert } from '../../utility/SweetAlert'

const InteractorNewsletterView = () => {
  const { t } = useTranslation()

  const newsletterView = useCallback(
    (payload, callback, loading) => {
      ApiService.jsonRequest('/communication-newsletter/view', payload, response => {
        if (response.status_code === 200) {
          callback(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: 1500,
            redirect: '/newsletter/manage',
          })
        }
        loading(false)
      })
    },
    [t],
  )

  return { newsletterView }
}

export default InteractorNewsletterView
